import * as React from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';
import './assessmentConfigPage.scss';

// toast
import 'react-toastify/dist/ReactToastify.css';

// flags 
import 'flag-icon-css/css/flag-icon.css';

// services
import {createItemGen, currentBaseUrl, currentUser, currentUserId, getGeneralSmartTableData, isUserLoggedIn, uploadItem} from '../../common/services';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

// reactstrap
// import {Col, Row } from 'reactstrap';
import SmartDataTable from 'react-smart-data-table'

// hidable progress
import HidableProgress from '../../common/hidableProgress.Component';

// tabs
import {Breadcrumb, BreadcrumbItem, Button,ButtonDropdown, Card, CardBody, CardHeader,Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Row, TabContent, Table, TabPane} from 'reactstrap';

class AssessmentConfigPage extends React.Component {
    public state = {
      activeTab: '1',
      assessments: [],
      assets: [],
      baseurl: currentBaseUrl(),
      behaviour_feedback: [],
      behaviourmodal: false,
      behaviours: [],
      currentquestionidx: 0,
      destination: '',
      feedbackmodal: false,
      groupmodal: false,
      icons: [],
      levelfields: {
        id: 'id',
        question: 'Question',
        },
      levelmodal: false,
      levels: [],
      levelstep: 0,
      leveluploadmodal: false,
      levelextrauploadmodal: false,
      loaded: false,
      mounted: false,
      navigate: false,
      perceptionfields: {
        id: 'id',
        name: 'Name'
        },
      perceptionmodal: false,
      perceptions: [],
      processingmodal: false,
      question_groups: [],
      tologin: false,
      uploadprogress: 0,
      uploadstatus: "active",
      username: '',
      videos: [],
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this); 
        this.setTab = this.setTab.bind(this); 
        this.grouptoggle = this.grouptoggle.bind(this); 
        this.leveltoggle = this.leveltoggle.bind(this); 
        this.perceptiontoggle = this.perceptiontoggle.bind(this); 
        this.behaviourtoggle = this.behaviourtoggle.bind(this);
        this.leveluploadtoggle = this.leveluploadtoggle.bind(this);
        this.levelextrauploadtoggle = this.levelextrauploadtoggle.bind(this);
        this.feedbacktoggle = this.feedbacktoggle.bind(this);  
        this.feedbackSubmit = this.feedbackSubmit.bind(this); 
        // progress
        this.onuploadprogress = this.onuploadprogress.bind(this);
        this.onuploadcomplete = this.onuploadcomplete.bind(this);
        // row buttons
        this.handleAddAnswerClicked = this.handleAddAnswerClicked.bind(this); 
        this.handleEditAnswerClicked = this.handleEditAnswerClicked.bind(this); 
        this.uploadExtraSubmit = this.uploadExtraSubmit.bind(this); 
    }

    public grouptoggle() {
        this.setState({
          groupmodal: !this.state.groupmodal,
        });
    }

    public leveltoggle() {
        this.setState({
          levelmodal: !this.state.levelmodal,
        });
    }

    public perceptiontoggle() {
        this.setState({
          perceptionmodal: !this.state.perceptionmodal,
        });
    }

    public leveluploadtoggle() {
        this.setState({
          leveluploadmodal: !this.state.leveluploadmodal,
        });
    }

    public levelextrauploadtoggle() {
        this.setState({
          levelextrauploadmodal: !this.state.levelextrauploadmodal,
         });
    }

    public behaviourtoggle() {
        this.setState({
          behaviourmodal: !this.state.behaviourmodal,
        });
    }

    public feedbacktoggle() {
        this.setState({
            feedbackmodal: !this.state.feedbackmodal,
        });
    }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public onuploadprogress(val) {
        console.log(val);
        this.setState({uploadprogress: parseFloat(val)})
    }

    public onuploadcomplete(resp, refreshpath, refreshkey, arraykey) {
        if(resp.code ===200){
            this.setState({uploadstatus: "success"});
            toast('Successful upload');
            this.setState({processingmodal: false});
            getGeneralSmartTableData( refreshpath, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));
            
            if(refreshkey ==='levels') {
                this.leveluploadtoggle();
                this.setState({levelextrauploadmodal: false});
            }
        }
        else{
            toast('Error uploading, check file');
            this.setState({processingmodal: false});
            this.setState({uploadstatus: "error"});
        }
    }


    public uploadSubmit = (event) => {
        event.preventDefault()

        const fileInputElement = event.target.elements.upld;
        const formData = new FormData();

        let hasFile = false;

        for (const row of fileInputElement.files) {
            if(this.checkFile(row.name)) {
                formData.append('files', row);
                hasFile = true;
            }
            console.log(row.name);
            // console.log('acceptable:', this.checkFile(row.name));
        }

        if(hasFile){
            this.setState({processingmodal: true})
            this.setState({uploadprogress: 0})
            this.setState({uploadstatus: "active"})
            uploadItem("admin/assessment_levels/csv_upload/", formData, text => this.onuploadprogress(text), text => this.onuploadcomplete(text, 'admin/assessment_levels/overview_items/', 'levels', 'levels'));
        }

        
    }

    public uploadExtraSubmit = (event) => {
        event.preventDefault()

        const fileInputElement = event.target.elements.upld;
        const formData = new FormData();

        let hasFile = false;

        for (const row of fileInputElement.files) {
            if(this.checkFile(row.name)) {
                formData.append('files', row);
                hasFile = true;
            }
            console.log(row.name);
            // console.log('acceptable:', this.checkFile(row.name));
        }

        if(hasFile){
            this.setState({processingmodal: true})
            this.setState({uploadprogress: 0})
            this.setState({uploadstatus: "active"})
            uploadItem("admin/assessment_levels/learner_copy/", formData, text => this.onuploadprogress(text), text => this.onuploadcomplete(text, 'admin/assessment_levels/overview_items/', 'levels', 'levels'));
        }

    }

    public behaviourSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Name: event.target.elements.name.value,
        }

        createItemGen( 'admin/behaviours/', item, text => this.handleGenCreatedItemLoaded('admin/behaviours/overview_items/', 'behaviours', 'behaviours',text));
      }

      public feedbackSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Behaviour: event.target.elements.behaviour.value,
            FeedbackText_capability: event.target.elements.capability.value,
            FeedbackText_intervention: event.target.elements.intervention.value,
            FeedbackText_manifestation: event.target.elements.manifestation.value,
            RangeHigh: event.target.elements.rhigh.value,
            RangeLow: event.target.elements.rlow.value,
        }
        
        createItemGen( 'admin/behaviour_feedback/', item, text => this.handleGenCreatedItemLoaded('admin/behaviour_feedback/overview_items/', 'behaviour_feedback', 'behaviour_feedback',text));
      }

    
    public perceptionSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        // answer
        const item = {
            Name: event.target.elements.Name.value,
        }

        createItemGen( 'admin/perception_levels/', item, text => this.handleGenCreatedItemLoaded('admin/perception_levels/overview_items/', 'perceptions', 'perception_levels',text));
      }

    public groupSubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            Colour: event.target.elements.color.value,
            Description: event.target.elements.description.value,
            Icon: event.target.elements.icon.value,
            Name: event.target.elements.title.value,
        }

        console.log(item);
        
        createItemGen( 'admin/assessment_question_groups/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_question_groups/overview_items/', 'question_groups', 'question_groups',text));
      }

    public levelsubmit = (event) => {
        event.preventDefault()
        this.setState({processingmodal: true})
        
        const item = {
            AttitudeBehavioursLearningPack: event.target.elements.AttitudeBehavioursLearningPack.value,
            ExplainerVideoUrl: event.target.elements.ExplainerVideoUrl.value,
            Grade: event.target.elements.Grade.value,
            GvtAssessedDescription: event.target.elements.GvtAssessedDescription.value,
            MentalHealthWelbeingPack: event.target.elements.MentalHealthWelbeingPack.value,
            PerceptionLevelEffortDeterminationWork: event.target.elements.PerceptionLevelEffortDeterminationWork.value,
            PerceptionLevelLearning: event.target.elements.PerceptionLevelLearning.value,
            PerceptionLevelReadinessEagernessLearn: event.target.elements.PerceptionLevelReadinessEagernessLearn.value,
            PerceptionLevelResponseSubjectDemands: event.target.elements.PerceptionLevelResponseSubjectDemands.value,
            PerceptionLevelSchool: event.target.elements.PerceptionLevelSchool.value,
            PerceptionLevelSelf: event.target.elements.PerceptionLevelSelf.value,
            PerceptionLevelShowingUpLearn: event.target.elements.PerceptionLevelShowingUpLearn.value,
            PerceptionLevelTeachers: event.target.elements.PerceptionLevelTeachers.value,
            PloaLevel: event.target.elements.PloaLevel.value,
            ProgressAttainmentPack: event.target.elements.ProgressAttainmentPack.value,
            RiskGroup: event.target.elements.RiskGroup.value,
            RiskLevel: event.target.elements.RiskLevel.value,
            TargetGrade: event.target.elements.TargetGrade.value,
            TargetPLOAScore: event.target.elements.TargetPLOAScore.value,
            Title: event.target.elements.Title.value,
            TraitCopy: event.target.elements.TraitCopy.value,
            Version: event.target.elements.Version.value,
            score_max: event.target.elements.score_max.value,
            score_min: event.target.elements.score_min.value,
        }

        createItemGen( 'admin/assessment_levels/', item, text => this.handleGenCreatedItemLoaded('admin/assessment_levels/overview_items/', 'levels', 'levels',text));
    
      }

      public handleGenSmartDataLoaded(key,objkey, res) {
        if(res.code ===200){
            console.log(key);
            this.setState({loaded: true});
            this.setState({[key]: res.response[objkey]});
        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }

    
    public handleGenCreatedItemLoaded(fetchendpoint,refreshkey, arraykey, res) {
        if(res.code ===200){
            toast('Request successful');
            getGeneralSmartTableData( fetchendpoint, text => this.handleGenSmartDataLoaded(refreshkey, arraykey,text));
            if(refreshkey === 'question_groups') {
                setTimeout(this.grouptoggle, 100); 
            } 
            else if(refreshkey === 'levels') {
                setTimeout(this.leveltoggle, 100); 
            } 
            else if(refreshkey === 'behaviours') {
                setTimeout(this.behaviourtoggle, 100); 
            } 
            else if(refreshkey === 'behaviour_feedback') {
                setTimeout(this.feedbacktoggle, 100); 
            } 
            else if(refreshkey === 'perceptions') {
                setTimeout(this.perceptiontoggle, 100); 
            } 
            
            this.setState({processingmodal: false});
        }
        if(res.code ===404){
            toast('Request failed, try again');
            this.setState({processingmodal: false});
        }
        if(res.code ===401){
            toast('Request unauthorized');
            this.onLogout('arg');
        }
    }


    public setTab(param, e) {
        this.setState({
        activeTab: param
         });
    }

    
    public openWidget(param, e) {
        console.log('widget: ' + param)
        this.setState({destination: currentBaseUrl() + param})
        this.setState({navigate: true})
    }

    public onChange(arg) {
        console.log('On change', arg);
    }

    public handleAddAnswerClicked(idx, e) {
        console.log('idx', idx);
        this.setState({currentquestionidx: idx});
        this.perceptiontoggle();
    }

    public handleEditAnswerClicked(idx, e) {
        console.log('idx', idx);
        this.setState({currentquestionidx: idx});
        this.leveluploadtoggle();
    }

    public onRowClick(event, { rowData, rowIndex, tableData }) {
        const { title } = rowData;
        console.log(title);
    }

    public componentDidMount() {
        if(!isUserLoggedIn()){
            this.setState({ tologin: true });
          }
        else{
            this.setState({ username: currentUser()});
            getGeneralSmartTableData( 'admin/assessment_question_groups/overview_items/', text => this.handleGenSmartDataLoaded('question_groups', 'question_groups',text));
            getGeneralSmartTableData( 'admin/icons/overview_items/', text => this.handleGenSmartDataLoaded('icons', 'icons',text));
            getGeneralSmartTableData( 'admin/assessment_levels/overview_items/', text => this.handleGenSmartDataLoaded('levels', 'levels',text));
            getGeneralSmartTableData( 'admin/perception_levels/overview_items/', text => this.handleGenSmartDataLoaded('perceptions', 'perception_levels',text));
            getGeneralSmartTableData( 'admin/assets/video_items/', text => this.handleGenSmartDataLoaded('videos', 'assets',text));
            getGeneralSmartTableData( 'admin/assets/overview_items/', text => this.handleGenSmartDataLoaded('assets', 'assets',text));
            getGeneralSmartTableData( 'admin/behaviours/overview_items/', text => this.handleGenSmartDataLoaded('behaviours', 'behaviours',text));
            getGeneralSmartTableData( 'admin/behaviour_feedback/overview_items/', text => this.handleGenSmartDataLoaded('behaviour_feedback', 'behaviour_feedback',text));
        }

        this.setState({ mounted: true});
        console.log(this.currentid());
    }

    public checkFile(fname) {
        let fileExtension = "";
        if (fname.lastIndexOf(".") > 0) {
            fileExtension = fname.substring(fname.lastIndexOf(".") + 1, fname.length);
        }
        if (fileExtension.toLowerCase() === "csv") {
            return true;
        }
        else {
            toast(fname + " is not a valid CSV file for upload");
            return false;
        }
    }

    public currentid (){
        const key1 = 'match';
        return this.props[key1].params.id
    }

    public questiondisplay (){
        if (this.state.levels.length > 0) {
            return (
                <h4>{this.state.levels[this.state.currentquestionidx][this.state.levelfields.question]}</h4> 
              );
        }
        else{
            return (
                <h4>No question to display</h4>  
              );
        }
    }

    

    public render() {
        if (this.state.tologin === true) {
           return <Redirect to='/login'/>
        }
        if (this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }

        const iconfields= {
            id: 'id',
            name: 'Title',
        }

        const behaviourfields= {
            id: 'id',
            name: 'Name',
        }


        const groupfields= {
            id: 'id',
            name: 'Title',
        }

        const assetfields= {
            filename: 'FileName',
            id: 'id',
            name: 'Title',
        }
        
        const behaviourfeedbackheaders = {
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }

        const levelheaders = {
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }

        const groupheaders = {
            
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }
        
        const perceptionheaders = {
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }

        const behaviourheaders = {
            id: {
                filterable: false,
                invisible: false,
                text: 'Id',
            },
            
        }

        const adminHomeStyles = {
            welcometext: {
                margin: 3,
                marginLeft: 13,
                marginTop: '2%'
            },

            modal:{
                width: '100%',
            },

            tabrow: {
                margin: 1,
                marginTop: '2%',
              },

            tabcontent: {
                margin: 1,
                marginTop: '2%'
            },

            tableHeaderButton: {
                margin: 2,
                marginLeft: 8,
            },

            widgetrow: {
              margin: 3,
              marginTop: '2%'
            },

            navitem: {
                margin: 3,
                padding: 5,
              },

              toast:{
                zIndex: 9999999,
            },
        }

        
        return (
            <div>

              <NavBar logoutParent={this.onLogout}/>

              <ToastContainer style={adminHomeStyles.toast} />

              <Breadcrumb>
                  <BreadcrumbItem><a onClick={this.openWidget.bind(this, 'home')}>Home</a></BreadcrumbItem>
                  <BreadcrumbItem active={true}>Assessmentconfig</BreadcrumbItem>
                </Breadcrumb>

              <div className="animated fadeIn">
                <Row style={adminHomeStyles.tabrow}>
                    <Col xs="12" md="12" style={{textAlign: 'center', color: 'white'}}>
                        <h4>Import Assessment Levels</h4>
                        <p>You can import a specially formatted file instead of manually typing in assessment level data. The uploaded data will automatically populate the list if successful. You can download a <a href="http://media.mypl.life/samples/AssessmentLevel0.5Secondary.csv" target="_blank">Sample</a> here to get started</p>
                        <Button onClick={this.leveluploadtoggle}>Import Levels From CSV</Button>

                        <Button style={{marginLeft: '7px'}} onClick={this.levelextrauploadtoggle}>Import learner-specific Data</Button>
                    
                    </Col>
                    <Col xs="12" md="12" className="mb-4">
                    <Nav tabs={true} style={{flexWrap: 'nowrap'}}>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink  onClick={this.setTab.bind(this, '1')}>
                                Groups
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '2')}>
                            Behaviour
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '3')}>
                                Feedback
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '4')}>
                                Levels
                            </NavLink>
                        </NavItem>
                        <NavItem style={adminHomeStyles.navitem}>
                            <NavLink onClick={this.setTab.bind(this, '5')}>
                                Perceptions
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <div>
                    <Modal isOpen={this.state.groupmodal} toggle={this.grouptoggle} className="">
                            <ModalHeader toggle={this.grouptoggle}>Create Question Group</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.groupSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="title">Group title</Label>
                                                <Input type="text" id="title" name="title" placeholder="Title" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="description">Group Description</Label>
                                                <Input type="text" id="description" name="description" placeholder="Description" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="icon">Icon</Label>
                                                <Input type="select" id="icon" name="icon" placeholder="Icon" required={true} >
                                                    {this.state.icons.map(d => <option key={d[iconfields.id]} value={d[iconfields.id]}> {d[iconfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="color">Color</Label>
                                                <Input type="select" id="color" name="color" placeholder="white" required={true} >
                                                    <option value="white">white</option>
                                                    <option value="red">Red</option>
                                                    <option value="blue">Blue</option>
                                                    <option value="grey">Grey</option>
                                                    <option value="pink">Pink</option>
                                                    <option value="green">Green</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button  type="submit" color="primary">Submit</Button>
                                        <Button  onClick={this.grouptoggle} color="secondary">Cancel</Button>
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        <Modal style={adminHomeStyles.modal} isOpen={this.state.levelmodal} toggle={this.leveltoggle} className="">
                            <ModalHeader toggle={this.leveltoggle}>Create Assessment Level</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.levelsubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="score_min">Score Min</Label>
                                                <Input type="text" id="score_min" name="score_min" placeholder="Minimum Score" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="score_max">Score Max</Label>
                                                <Input type="text" id="score_max" name="score_max" placeholder="Maximum Score" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="RiskLevel">RiskLevel</Label>
                                                <Input type="text" id="RiskLevel" name="RiskLevel" placeholder="RiskLevel" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="RiskGroup">RiskGroup</Label>
                                                <Input type="text" id="RiskGroup" name="RiskGroup" placeholder="RiskGroup" required={true} />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PloaLevel">PloaLevel</Label>
                                                <Input type="select" id="PloaLevel" name="PloaLevel" placeholder="no" required={true} >
                                                    <option value="PLOA_PRIMARY">PLOA_PRIMARY</option>
                                                    <option value="PLOA_SECONDARY">PLOA_SECONDARY</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PloaLevel">Version</Label>
                                                <Input type="select" id="Version" name="Version" placeholder="no" required={true} >
                                                    <option value="0.5">0.5</option>
                                                    <option value="1.0">1.0</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="ProgressAttainmentPack">ProgressAttainmentPack</Label>
                                                <Input type="select" id="ProgressAttainmentPack" name="ProgressAttainmentPack" placeholder="no" required={true} >
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="MentalHealthWelbeingPack">MentalHealthWelbeingPack</Label>
                                                <Input type="select" id="MentalHealthWelbeingPack" name="MentalHealthWelbeingPack" placeholder="no" required={true} >
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="AttitudeBehavioursLearningPack">AttitudeBehavioursLearningPack</Label>
                                                <Input type="select" id="AttitudeBehavioursLearningPack" name="AttitudeBehavioursLearningPack" placeholder="no" required={true} >
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelShowingUpLearn">PerceptionLevelShowingUpLearn</Label>
                                                <Input type="select" id="PerceptionLevelShowingUpLearn" name="PerceptionLevelShowingUpLearn" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelSchool">PerceptionLevelSchool</Label>
                                                <Input type="select" id="PerceptionLevelSchool" name="PerceptionLevelSchool" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelLearning">PerceptionLevelLearning</Label>
                                                <Input type="select" id="PerceptionLevelLearning" name="PerceptionLevelLearning" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelSelf">PerceptionLevelSelf</Label>
                                                <Input type="select" id="PerceptionLevelSelf" name="PerceptionLevelSelf" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelReadinessEagernessLearn">PerceptionLevelReadinessEagernessLearn</Label>
                                                <Input type="select" id="PerceptionLevelReadinessEagernessLearn" name="PerceptionLevelReadinessEagernessLearn" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelTeachers">PerceptionLevelTeachers</Label>
                                                <Input type="select" id="PerceptionLevelTeachers" name="PerceptionLevelTeachers" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelEffortDeterminationWork">PerceptionLevelEffortDeterminationWork</Label>
                                                <Input type="select" id="PerceptionLevelEffortDeterminationWork" name="PerceptionLevelEffortDeterminationWork" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="PerceptionLevelResponseSubjectDemands">PerceptionLevelResponseSubjectDemands</Label>
                                                <Input type="select" id="PerceptionLevelResponseSubjectDemands" name="PerceptionLevelResponseSubjectDemands" placeholder="order" required={true} >
                                                    {this.state.perceptions.map((d, i) => <option key={d[this.state.perceptionfields.id]} value={d[this.state.perceptionfields.id]}>  {d[this.state.perceptionfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="Title">Title</Label>
                                                <Input type="text" id="Title" name="Title" placeholder="Trait Title" required={true} />
                                                    
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="TraitCopy">TraitCopy</Label>
                                                <textarea style={{height: 200}} id="TraitCopy" name="TraitCopy" placeholder="TraitCopy" required={true} />
                                                    
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="TargetPLOAScore">TargetPLOAScore</Label>
                                                <Input type="text" id="TargetPLOAScore" name="TargetPLOAScore" placeholder="TargetPLOAScore" required={true} />
                                                    
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="Grade">Grade</Label>
                                                <Input type="text" id="Grade" name="Grade" placeholder="Grade" required={true} />
                                                    
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="TargetGrade">TargetGrade</Label>
                                                <Input type="text" id="TargetGrade" name="TargetGrade" placeholder="TargetGrade" required={true} />
                                                    
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="GvtAssessedDescription">GvtAssessedDescription</Label>
                                                <Input type="text" id="GvtAssessedDescription" name="GvtAssessedDescription" placeholder="GvtAssessedDescription" required={true} />
                                                    
                                            </FormGroup>
                                        </Col>

                                        
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="ExplainerVideoUrl">Explainer Video</Label>
                                                <Input type="select" id="ExplainerVideoUrl" name="ExplainerVideoUrl" placeholder="asset" required={true} >
                                                    {this.state.videos.map(d => <option key={d[assetfields.id]} value={d[assetfields.filename]}> {d[assetfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.leveltoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        <Modal style={adminHomeStyles.modal} isOpen={this.state.perceptionmodal} toggle={this.perceptiontoggle} className="">
                            <ModalHeader toggle={this.perceptiontoggle}>Create Perception</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.perceptionSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="Name">Name</Label>
                                                <Input type="text" id="Name" name="Name" placeholder="Name" required={true} />
                                            </FormGroup>
                                        </Col>
                                        
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.perceptiontoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>

                        <Modal style={adminHomeStyles.modal} isOpen={this.state.behaviourmodal} toggle={this.behaviourtoggle} className="">
                            <ModalHeader toggle={this.behaviourtoggle}>Create Behaviour</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.behaviourSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="name">Name</Label>
                                                <Input type="text" id="name" name="name" placeholder="Name" required={true} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.behaviourtoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        <Modal style={adminHomeStyles.modal} isOpen={this.state.feedbackmodal} toggle={this.feedbacktoggle} className="">
                            <ModalHeader toggle={this.feedbacktoggle}>Create Behaviour Feedback</ModalHeader>
                            <ModalBody>
                            <form onSubmit={this.feedbackSubmit}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="rlow">RangeLow</Label>
                                                <Input type="text" id="rlow" name="rlow" placeholder="Range Low" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="rhigh">RangeHigh</Label>
                                                <Input type="text" id="rhigh" name="rhigh" placeholder="Range High" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="capability">Capability</Label>
                                                <Input type="text" id="capability" name="capability" placeholder="capability" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="manifestation">Manifestation</Label>
                                                <Input type="text" id="manifestation" name="manifestation" placeholder="manifestation" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="intervention">Intervention</Label>
                                                <Input type="text" id="intervention" name="intervention" placeholder="intervention" required={true} />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label className="frm-modal-label" htmlFor="behaviour">Behaviour</Label>
                                                <Input type="select" id="behaviour" name="behaviour" placeholder="behaviour" required={true} >
                                                    {this.state.behaviours.map(d => <option key={d[behaviourfields.id]} value={d[behaviourfields.id]}> {d[behaviourfields.name]}</option>)}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.feedbacktoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={this.state.leveluploadmodal} toggle={this.leveluploadtoggle} className="">
                            <ModalHeader toggle={this.leveluploadtoggle}>Upload Assessment Levels</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.uploadSubmit}>
                                    <Row>
                                        
                                        <Col xs="12">
                                            <FormGroup>
                                                <input id="upld" type="file" name="upld" accept=".csv" multiple={true} required={true}/>
                                            </FormGroup>
                                        </Col>


                                        <Col xs="12">
                                            <FormGroup>
                                                <HidableProgress uploadprogress={this.state.uploadprogress} uploadstatus={this.state.uploadstatus} visible={this.state.processingmodal}/>
                                            </FormGroup>
                                        </Col>
                                        
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.leveluploadtoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={this.state.levelextrauploadmodal} toggle={this.levelextrauploadtoggle} className="">
                            <ModalHeader toggle={this.levelextrauploadtoggle}>Upload Learner Level Data</ModalHeader>
                            <ModalBody>
                                <form onSubmit={this.uploadExtraSubmit}>
                                    <Row>
                                        
                                        <Col xs="12">
                                            <FormGroup>
                                                <input id="upld" type="file" name="upld" accept=".csv" multiple={true} required={true}/>
                                            </FormGroup>
                                        </Col>


                                        <Col xs="12">
                                            <FormGroup>
                                                <HidableProgress uploadprogress={this.state.uploadprogress} uploadstatus={this.state.uploadstatus} visible={this.state.processingmodal}/>
                                            </FormGroup>
                                        </Col>
                                        
                                    </Row>
                                    <Loader loaded={!this.state.processingmodal}>
                                        <Button color="primary"  type="submit">Submit</Button>
                                        <Button  onClick={this.levelextrauploadtoggle}>Cancel</Button> 
                                    </Loader>
                                </form>
                            </ModalBody>
                        </Modal>
                    </div>
                    <TabContent activeTab={this.state.activeTab} style={adminHomeStyles.tabcontent}>
                        <TabPane tabId="1">
                            <Card className="admincard">
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Question Groups
                                    <Button color="primary" onClick={this.grouptoggle}  style={adminHomeStyles.tableHeaderButton}>New Group</Button>
                                </CardHeader>
                                <CardBody>

                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                            data={this.state.question_groups}
                                            headers={groupheaders}
                                            name='Groups'
                                            perPage={10}
                                            className='ui compact selectable table admintable'
                                            sortable={false}
                                            onRowClick={this.onRowClick}
                                        />
                                    </Loader>
                                </CardBody>
                            </Card>
                        
                        </TabPane>
                        <TabPane tabId="2">
                        <Card className="admincard">
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Behaviours
                                    <Button color="primary" onClick={this.behaviourtoggle}  style={adminHomeStyles.tableHeaderButton}>New Behaviour</Button>
                                </CardHeader>
                                <CardBody>
                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                        data={this.state.behaviours}
                                        headers={behaviourheaders}
                                        name='Behaviours'
                                        perPage={10}
                                        className='ui compact selectable table admintable'
                                        sortable={false}
                                        onRowClick={this.onRowClick}
                                    />
                                    </Loader>
                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="3">
                        <Card className="admincard">
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Behaviour Feedback
                                    <Button color="primary" onClick={this.feedbacktoggle}  style={adminHomeStyles.tableHeaderButton}>New Feedback</Button>
                                </CardHeader>
                                <CardBody>
                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                        data={this.state.behaviour_feedback}
                                        headers={behaviourfeedbackheaders}
                                        name='Behaviour Feedback'
                                        perPage={10}
                                        className='ui compact selectable table admintable'
                                        sortable={false}
                                        onRowClick={this.onRowClick}
                                    />
                                    </Loader>
                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="4">
                            <Card className="admincard">
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Assessment levels
                                    <Button color="primary" onClick={this.leveltoggle}  style={adminHomeStyles.tableHeaderButton}>New Level</Button>
                                </CardHeader>
                                <CardBody>
                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                        data={this.state.levels}
                                        headers={levelheaders}
                                        name='levels'
                                        perPage={10}
                                        className='ui compact selectable table admintable'
                                        sortable={false}
                                        onRowClick={this.onRowClick}
                                    />
                                    </Loader>
                                </CardBody>
                            </Card>
                        </TabPane>
                        <TabPane tabId="5">
                            <Card className="admincard">
                                <CardHeader>
                                    <i className="fa fa-align-justify"/> Perception levels
                                    <Button color="primary" onClick={this.perceptiontoggle}  style={adminHomeStyles.tableHeaderButton}>New Perception</Button>
                                </CardHeader>
                                <CardBody>
                                    <Loader loaded={this.state.loaded}>

                                        <SmartDataTable
                                        data={this.state.perceptions}
                                        headers={perceptionheaders}
                                        name='perceptions'
                                        perPage={10}
                                        className='ui compact selectable table admintable'
                                        sortable={false}
                                    />
                                    </Loader>
                                </CardBody>
                            </Card>
                        </TabPane>
                        
                    </TabContent>
                </Col>
          </Row>
              
              </div>
              
            </div>      
        )
    }
}

export default AssessmentConfigPage;


// WEBPACK FOOTER //
// ./src/pages/Assessmentconfig/assessmentConfigPage.Component.tsx